'use client';

import React, { useEffect, useRef } from 'react';
import { memberRedirectAtom } from '@/state';
import { Box, Button, Card, CardActions, CardContent } from '@mui/material';
import { useSetAtom } from 'jotai';
import { usePathname } from 'next/navigation';
import { sendGTMEvent } from '@next/third-parties/google';

interface FreeAccountCTAProps {
  isLoggedIn: boolean;
}

export const FreeAccountCTA = ({ isLoggedIn }: FreeAccountCTAProps) => {
  const effectRan = useRef<boolean>(false);

  //#region Membership redirect
  // If we're displaying a Professional membership CTA, then cache the page pathname for redirection; if the
  // user signs up via this CTA, then we want to return them to this page following a successful signup
  const pathname = usePathname();
  const setMemberRedirect = useSetAtom(memberRedirectAtom);
  useEffect(() => {
    setMemberRedirect(pathname);
  }, []);
  //#region Membership redirect

  useEffect(() => {
    if (!effectRan.current) {
      sendGTMEvent({
        event: 'cta_shown',
        cta_type: 'free'
      });
    }
    effectRan.current = true;
  }, []);

  return (
    <Card
      variant='outlined'
      color='secondary'
      sx={{ padding: { xs: '20px', sm: '30px', md: '40px' } }}
      className='paywall-container'
    >
      <CardContent>
        <Box>
          <h1 className='article__name'>Want to watch the recording?</h1>
        </Box>
        <Box>
          <p>You can access this content with a free TUD account.</p>
        </Box>
      </CardContent>
      <CardActions className='button-container'>
        <Button
          href={'/signin'}
          style={{
            background: 'none',
            border: '1px solid var(--Secondary-Grey-60, #959595)'
          }}
          variant='contained'
          disableElevation
        >
          {'Sign In'}
        </Button>
        <Button
          href={'/signup?product=Free'}
          style={{ marginLeft: '0', textAlign: 'center' }}
          variant='contained'
          disableElevation
        >
          Register Now
        </Button>
      </CardActions>
    </Card>
  );
};
